import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, firstValueFrom, tap } from 'rxjs';
import { WebSocketSubject, webSocket } from 'rxjs/webSocket';
import { environment } from 'src/environments/environment';
import { BranchIndexedDBService } from '../indexDB/branch.service';
import { LoanOfficerIndexedDBService } from '../indexDB/loanOfficer.service';
import { AreaIndexedDBService } from '../indexDB/area.service';
import { LoanProductIndexedDBService } from '../indexDB/loanProduct.service';
import { DepositProductIndexedDBService } from '../indexDB/depositProduct.service';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
    baseCoreUrl: string = environment.baseUrl + environment.coreUrl;
    baseAccountUrl: string = environment.baseUrl + environment.accountUrl;
    private socket$: WebSocketSubject<any>;

    constructor(
        private http: HttpClient,
        private branchIndexedDBService: BranchIndexedDBService,
        private areaIndexedDBService: AreaIndexedDBService,
        private loanOfficerIndexedDBService: LoanOfficerIndexedDBService,
        private loanProductIndexedDBService: LoanProductIndexedDBService,
        private depositProductIndexedDBService: DepositProductIndexedDBService
        ) {
        this.socket$ = webSocket('ws://localhost:3000'); // Replace with your Java WebSocket server URL

        // this.socket$.subscribe((message: any) => {
        // if (message.type === 'branch-update') {
        //     this.updateBranchList();
        // } else if (message.type === 'area-update') {
        //     this.updateAreaList();
        // } else if (message.type === 'loanOfficer-update') {
        //     this.updateLoanOfficer();
        // } else if (message.type === 'loanProduct-update') {
        //     this.updateLoanProduct();
        
        // } else if (message.type === 'depositProduct-update') {
        //     this.updateDepositProduct();
        // }
        // });

    }

    updateBranchList(): Observable<any> {
        return this.http.get(`${this.baseCoreUrl}branch/list-branch?sort-field=name&sort-order=ASC`).pipe(
          tap((res: any) => {
            const branches = res.data;
            this.branchIndexedDBService.storeDataInIndexedDB(branches.map(branch => ({ id: branch.id, name: branch.name, areaId: branch.areaId })));
          }),
          catchError((error) => {
            console.error('Error updating branch list:', error);
            return [];
          })
        );
    }
    
    updateAreaList(): Observable<any> {
        return this.http.get(`${this.baseCoreUrl}areas/all-areas?sort-field=name&sort-order=ASC`).pipe(
            tap((res: any) => {
            const areas = res.data;
            this.areaIndexedDBService.storeDataInIndexedDB(areas.map(area => ({ id: area.areaId, name: area.areaName})));
            }),
            catchError((error) => {
            console.error('Error updating area list:', error);
            return [];
            })
        );
    }
    
    updateLoanOfficer(): Observable<any> {
        return this.http.get(`${this.baseCoreUrl}users/loan-officers`).pipe(
            tap((res: any) => {
            const loanOfficers = res.data;
            this.loanOfficerIndexedDBService.storeDataInIndexedDB(loanOfficers.map(loanOfficer => ({ id: loanOfficer.id, name: loanOfficer.name, branchId: loanOfficer.branch_id, areaId: loanOfficer.area_id })));
            }),
            catchError((error) => {
            console.error('Error updating account officers:', error);
            return [];
            })
        );
    }
    
    updateLoanProduct(): Observable<any> {
        return this.http.get(`${this.baseAccountUrl}loan-products/getAllLoanProducts`).pipe(
            tap((res: any) => {
            const products = res.data;
            this.loanProductIndexedDBService.storeDataInIndexedDB(products.map(product => ({ id: product.id, name: product.name})));
            }),
            catchError((error) => {
            console.error('Error updating loan products:', error);
            return [];
            })
        );
    }
    
    updateDepositProduct(): Observable<any> {
        return this.http.get(`${environment.baseUrl}accounts/savings-products/all`).pipe(
            tap((res: any) => {
            const products = res.data;
            this.depositProductIndexedDBService.storeDataInIndexedDB(products.map(product => ({ id: product.id, name: product.name})));
            }),
            catchError((error) => {
            console.error('Error updating deposit products:', error);
            return [];
            })
        );
    }


    public async storeIndexedDbData() {
        await Promise.all([
          firstValueFrom(this.updateAreaList()).catch(() => {}),
          firstValueFrom(this.updateBranchList()).catch(() => {}),
          firstValueFrom(this.updateLoanOfficer()).catch(() => {}),
          firstValueFrom(this.updateLoanProduct()).catch(() => {}),
          firstValueFrom(this.updateDepositProduct()).catch(() => {}),
        ]);
        localStorage.setItem('isIndexDBFetched', 'true');
    }
}